{
  "09fb67d57bc78f93": "Add a passkey",
  "0c89d866efe705b5": "Don't know your current password or don't have one yet?",
  "11097d9deb0ad0ae": "Passkey removed",
  "11a6767d5674c7e4": "Done",
  "130011756125313c": "On",
  "1509f561f2416598": "Save",
  "18ac6380138bdd5b": "Daily Summary Time",
  "19766ed6ccb2f4a3": "Cancel",
  "1b21c5e9cfc510fb": "Are you sure you want to deactivate?",
  "1c30dea370683e3c": "You haven't added any passkeys yet.",
  "1e3564bdba890599": "Notification Preferences",
  "1f7227ba0c569543": "Deactivate Account",
  "203c79fe20bbf056": "&#x2022;",
  "259a1c90bc00df46": "Please enter a valid US mobile number.",
  "25de2f171b5bb91f": "Password reset email sent to {{userEmail}}.",
  "285e229fe9526851": "Your account is missing an email address. Please contact support.",
  "286a3af7348e8312": "Sending...",
  "28ad230b46ce7f37": "Landline",
  "312873712eff4228": "Failed to deactivate user",
  "3dd9df4441fb348f": "New password",
  "3e2a22f4bbb80ade": "Unlink Account",
  "3f9c991f63a9a376": "Change password",
  "464c4ffd019e1e96": "Edit",
  "4ba2056e9ba62960": "Web Push",
  "56ad18c6bbb2efc6": "Are you sure you want to unlink from {{workplaceName}}?",
  "5c81e533cbb65983": "SMS notifications are disabled because no mobile number is set. Add a mobile number in Personal Information to enable SMS notifications.",
  "5d30556f50ec96d6": "Failed to update personal information",
  "5e31b73d3d36bee7": "Deactivate account",
  "5e7f0d7d6c6a94e7": "We couldn't load your passkeys. Please try again.",
  "60d18e42fd5a5b25": "Removing...",
  "72ed2bd767cef627": "Current password",
  "731ce7ed808913b2": "Push",
  "8db6b6ec511e793b": "A passkey lets you sign in with your device's fingerprint, face, or screen lock — no password or email link needed. It's faster and more secure. After adding one, choose \"Sign in with a passkey\" on the login screen and confirm with your device.",
  "8fb9beb223ae544b": "Failed to load account details. Please try again.",
  "904c9aa9baaef704": "Passkey",
  "929b1b5635346bbd": "Send a reset email",
  "942087cc2d41e013": "Retry",
  "958e4ccf2953d747": "Please enter a valid email address.",
  "969ccbd3cf6300ec": "Email",
  "96ce6e6193a04726": "First Name",
  "999bd6c24bbb567c": "Don't know your current password?",
  "9e12da5e3227bf5d": "Failed to unlink user",
  "a6ac8a2a2f638962": "Edit Personal Information",
  "a949f46230748d3f": "Change Password",
  "ad0187add790ff17": "My Account",
  "b286c7f6e0ef9fb1": "Mobile Phone",
  "b328c0544845a4f8": "Please enter a valid US landline number.",
  "b36c2611dcdfa190": "Daily",
  "b6eb82cd3300c838": "Passwords do not match",
  "bab342a878b1b458": "Your passkeys",
  "baefbeca157e01b4": "Only add a passkey on a device that's yours. Don't add one on a shared or public computer — anyone who can unlock that device could sign in as you.",
  "bb1d910d2ce54d39": "will lose access to {{workplaceName}}, but will maintain access to other workplaces:",
  "bf000421aeb39493": "Confirm new password",
  "c3812fc4acb861d5": "Remove",
  "c4b37e84b553d29b": "Personal Information",
  "c87ccdb428e6e24c": "Passkeys",
  "ca009c3212e4e3d0": "Your new password can't start or end with a space.",
  "ca7981b46ecf2c17": "Off",
  "d493798b58334f24": "Password changed successfully",
  "d4c687a498dfad56": "Unlink from workplace",
  "dcd1d5223f73b3a9": "Name",
  "dcd91a1072001642": "Passkey added",
  "de2c883522422d43": "Job Title",
  "e3b8d09d1ac4b9f1": "Password must be at least 8 characters",
  "e7d7f144db509e75": "Send an email to set up your new password",
  "eea61c4a94b11c2e": "Added {{date}}",
  "f1cac3406440c4e1": "Manage passkeys",
  "f2b1e1fd996e14eb": "will lose access to all associated workplaces and will no longer be able to log in.",
  "f55563b386a39dc3": "Last Name"
}
